import { AppButton, AppCard, AppInputGroup, AppLabel, AppModal } from "@dcam/dcam_flhealth_component_library";
import React, { useEffect, useState } from "react";
import {
  Accordion,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  // etc...
} from "react-bootstrap";
import useGetData from "../../hooks/useGetData";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import usePost from "../../hooks/usePost";
import { RoleData } from "../Dashboard/Dashboard.types";
import { CreateUserFormValidationSchema, UserDataFormRequest } from "../UserManagement/CreateUser.types";
import { yupResolver } from "@hookform/resolvers/yup";
import { ApiResponse } from "../Dashboard/ApiResponse";
import { useNavigate } from "react-router-dom";
import { FacilityRegistrationValidationSchema } from "./FacilityRegistration.types";
import formatPhoneNumber from "../../helpers/formatPhoneNumber";
import { useParams, useSearchParams } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { fal } from "@fortawesome/pro-light-svg-icons";


interface DropdownItem {
  value: string;
  text: string;
}

interface SelectOption {
  id: string;
  value: string;
}

export interface HospitalRegistrationRequest {
  userEmail: string;
  hospitalName: string;
  hospitalTypeId: number;
  hospitalAddress: string;
  hospitalCity: string;
  hospitalZipCode: string;
  stateId: number;
  countyId: number;
  userFirstName: string;
  userLastName: string;
  userPhoneNumber: string;
  roleId?: number | null;
  isApproved?: boolean | null;
  createdBy?: string | null;
  dateCreated?: string | null;
  hospitalTypeName?: string;
  countyName?: string;
}


const FacilityRegistration: React.FC = () => {

  const { instance, accounts } = useMsal();

  const account = accounts[0];
  const loggedInUser = accounts[0] && accounts[0].username;

  const { Id, type } = useParams(); // Path parameter
  const navigate = useNavigate();
  const methods = useForm<HospitalRegistrationRequest>({
    resolver: yupResolver(FacilityRegistrationValidationSchema)
  });

  const {
    handleSubmit,
    getValues,
    trigger,
    setValue,
    formState: { errors },
  } = methods;

  const [states, setStates] = useState<SelectOption[]>([]);
  const [counties, setCounties] = useState<SelectOption[]>([]);
  const [allRolesData, setAllRolesData] = useState<SelectOption[]>([]);
  const [emailError, setEmailError] = useState("");
  const [emailErrorColor, setEmailErrorColor] = useState("");
  const [fieldsEnabled, setFieldsEnabled] = useState(false);
  const [allRoutinizedHospitalsData, setallRoutinizedHospitalsData] = useState<SelectOption[]>([]);
  const [filteredRoutinizedFacilities, setFilteredRoutinizedFacilities] = useState<SelectOption[]>([]);
  const [selectedHospitalId, setSelectedHospitalId] = useState<number | null>(null);
  const [isHospitalSubmitting, setIsHospitalSubmitting] = useState(false);
  const [hospitalTypes, setHopitalTypes] = useState<SelectOption[]>([]);

  const initialHospitalData = {
    hospitalTypeId: 0,
    hospitalName: "",
    hospitalAddress: "",
    hospitalCity: "",
    stateId: 0,
    countyId: "",
    hospitalZipCode: "",
    //FacilityPhone: "",
    userFirstName: "",
    userLastName: "",
    userPhoneNumber: "",
    roleId: "",
    userEmail: ""
  };
  const [hospitalData, setHospitalData] = useState(initialHospitalData);
  const [stateIdData, setStateId] = useState(0);
  const [hospitalCityData, sethospitalCity] = useState("");
  const [userEmailData, setuserEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState(true);

  const { getDataById: getStates } = useGetData<SelectOption[], string>(
    "Client/States",
    "GET"
  );

  const { getDataById: getHospitalTypes } = useGetData<SelectOption[], string>(
    "Client/GetHospitalTypes",
    "GET"
  );

  const { getDataById: getCounties } = useGetData<SelectOption[], string>(
    "Client/Counties",
    "GET"
  );

  const { getDataById: getRoles } = useGetData<RoleData[], string>(
    "Client/Roles",
    "GET"
  );

  const { postByObject: postUser } = usePost<number, UserDataFormRequest>(
    "UserSecurity/Update",
    "POST"
  );

  const { getDataById: checkEmailExist } = useGetData(
    `UserSecurity/CheckUserByEmail`,
    "GET"
  );

  const { getDataById: getRoutinizedHospitals } = useGetData<
    SelectOption[],
    string
  >("Client/RoutinizedHospitals", "GET");

  const { getDataById: getRoutinizedFacilities } = useGetData<
    SelectOption[],
    string
  >("Client/RoutinizedFacilities", "GET");

  const { postByObject: postHospitalRegistration } = usePost<
    ApiResponse,
    HospitalRegistrationRequest
  >("HospitalRegistration/AddHospital", "POST");


  const { postByObject: ApproveRejectHospitalRegistration } = usePost<
    ApiResponse,
    any
  >("HospitalRegistration/StatusUpdateHospitalRegistration", "POST");

  const { getDataById: getFacilityById } = useGetData<any, string>(
    "HospitalRegistration/GetHospitalRegistrationsById",
    "GET"
  );

  const { getDataById: getUserId } = useGetData<any, string>(
    "UserSecurity/GetUserSecurityByEmail/" + account.username,
    "GET"
  );



  useEffect(() => {
    setValue("stateId", 10)
    const userDetails = async () => {
      const userData = await getUserId("");
      if (!userData?.user?.isActive) {
        navigate('/unauthorized');
      }
      else {
        const fetchHospitals = async () => {
          let data = await getFacilityById(Id ?? ""); // Fetch hospital types
          if (data) {
            setHospitalData(data);
            setStateId(data?.stateId);
            sethospitalCity(data?.hospitalCity)
            setuserEmail(data?.userEmail)
            setValue("hospitalName", data?.hospitalName)
            setValue("hospitalTypeId", Number(data?.hospitalTypeId))
            setValue("hospitalTypeName", data?.hospitalTypeName)
            setValue("hospitalAddress", data?.hospitalAddress)
            setValue("hospitalCity", data?.hospitalCity)
            //setValue("stateId",data?.stateId)
            setValue("countyId", Number(data?.countyId))
            setValue("countyName", data?.countyName)
            setValue("hospitalZipCode", data?.hospitalZipCode)


            setValue("userFirstName", data?.userFirstName)
            setValue("userLastName", data?.userLastName)
            setValue("userPhoneNumber", data?.userPhoneNumber)
            setValue("userEmail", data?.userEmail)

            if (type == "Edit") {
              setFieldsEnabled(true);
            }
          }
        };

        if (type) {
          fetchHospitals();
        }

        // Fetch states and counties using your API hooks or client
        const fetchStatesAndCounties = async () => {
          const stateData = await getStates(""); // Replace with actual API call
          const countyData = await getCounties(""); // Replace with actual API call
          setStates(stateData || []);
          setCounties(countyData || []);
        };

        fetchStatesAndCounties();

        const fetchHospitalTypes = async () => {
          let data = await getHospitalTypes(""); // Fetch hospital types
          if (data) {
            const mappedData = data.map((item) => ({
              id: item.id.toString(),
              value: item.value,
            }));

            // Add "Select Hospital Type" as the first option
            setHopitalTypes(mappedData);
          }
        };

        fetchHospitalTypes();

        const fetchRoles = async () => {
          const roleData = await getRoles("");
          if (roleData) {
            const mappedRoles = roleData.map((item) => ({
              id: item.id.toString(),
              value: item.value,
            }));

            setAllRolesData([
              ...mappedRoles,
            ]);
          }
        };

        fetchRoles();
      }
    }
    userDetails();
  }, []);


  // useEffect(() => {
  //   const fetchRoutinizedHospitals = async () => {
  //     let data = await getRoutinizedHospitals("");
  //     if (data) {
  //       const mappedData = data.map((item) => ({
  //         id: item.id.toString(),
  //         value: item.value,
  //       }));

  //       // Add "Select Facility" as the first option
  //       setallRoutinizedHospitalsData([
  //         { id: "", value: "Select Facility" },
  //         ...mappedData,
  //       ]);
  //     }
  //   };

  //   fetchRoutinizedHospitals();
  // }, []);


  // const handleRoutinizedHospitalChange = async (
  //   e: React.ChangeEvent<HTMLSelectElement>
  // ) => {
  //   const hospitalId = parseInt(e.target.value, 10);
  //   setSelectedHospitalId(hospitalId); // Update state with selected hospital ID
  //   setFilteredRoutinizedFacilities([]); // Clear facility options

  //   if (hospitalId) {
  //     const facilitiesData = await getRoutinizedFacilities(
  //       hospitalId.toString()
  //     );
  //     if (facilitiesData) {
  //       const mappedFacilities = facilitiesData.map((item) => ({
  //         id: item.id.toString(),
  //         value: item.value,
  //       }));
  //       setFilteredRoutinizedFacilities([
  //         { id: "", value: "Select Facility" },
  //         ...mappedFacilities,
  //       ]);
  //     }
  //   }
  // };

  const handleValidateEmail = async () => {
    const isValid = await methods.trigger("userEmail");
    if (!isValid) return;

    const email = methods.getValues("userEmail");

    try {
      const data = await checkEmailExist(email);

      if (data === true) {
        setEmailError(
          "Email already exists cannot be used, try another email."
        );
        toast.error("Email already exists cannot be used, try another email.", {
          position: "top-right",
          autoClose: 2000,
        });
        setEmailErrorColor("red");
        setFieldsEnabled(false);
      } else if (data === false) {
        setEmailError("Email Address can be used!");
        toast.success("Email Address can be used!", {
          position: "top-right",
          autoClose: 2000,
        });
        setEmailErrorColor("green");
        setFieldsEnabled(true);
      } else {
        setFieldsEnabled(false);
      }
    } catch (error) {
      console.error("API call failed", error);
      setFieldsEnabled(false);
    }
  };

  const onSubmit = async (formData: any) => {
    // If you’re already submitting, don’t do anything else.
    if (isHospitalSubmitting) return;

    setIsHospitalSubmitting(true);

    // 1. Confirm user action
    if (!type || type == "Edit") {
      const userConfirmed = window.confirm(
        "Please confirm if you would like to save the hospital data?"
      );
      if (!userConfirmed) {
        setIsHospitalSubmitting(false);
        return;
      }
      formData.hospitalRegistrationId = Id;
      // 2. Build the final request from the validated `formData`
      const hospitalRequest: HospitalRegistrationRequest = {
        ...formData,                 // Spread the validated data
        roleId: 2,                   // override or set as needed
        isApproved: null,            // override
        createdBy: "Admin",          // override
        dateCreated: new Date().toISOString(),
        updatedBy: "",
      };

      try {
        await postHospitalRegistration(hospitalRequest);

        // 3. Show success toast
        toast.success("Hospital data saved successfully!", {
          position: "top-right",
          autoClose: 2000,
        });

        // 4. Redirect or clear

        if (type == "Edit") {
          navigate('/Facility/Review');
        }
        else {
          navigate(`/success?email=${encodeURIComponent(formData.userEmail)}`);
        }
      } catch (error) {
        console.error("Error saving hospital data:", error);
        toast.error("An error occurred while saving hospital data.", {
          position: "top-right",
          autoClose: 2000,
        });
      } finally {
        setIsHospitalSubmitting(false);
      }
    }


  };

  const handleReject = () => {
    console.log("Rejected");
    // Add your reject logic here
  };

  const handleApprove = async () => {
    setSubmitStatus(false);
    const hospitalRequest: any = {
      roleId: 2,                   // override or set as needed
      isApproved: true,            // override
      createdBy: "Admin",          // override
      dateCreated: new Date().toISOString(),
      hospitalRegistrationId: Number(Id),
      hospitalName: "",
      updatedBy: loggedInUser
    };

    try {
      await ApproveRejectHospitalRegistration(hospitalRequest);

      // 3. Show success toast
      toast.success("Hospital data approved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });

      // 4. Redirect or clear
      navigate('/Facility/Review');
    } catch (error) {
      console.error("Error saving hospital data:", error);
      toast.error("An error occurred while saving hospital data.", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setIsHospitalSubmitting(false);
    }

  };


  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectComment, setRejectComment] = useState("");

  const handleRejectClick = () => {
    setIsRejectModalOpen(true);
  };

  const handleModalClose = () => {
    setIsRejectModalOpen(false);
    setRejectComment("");
  };

  const handleRejectSubmit = async () => {

    setIsRejectModalOpen(false);
    setSubmitStatus(false);
    const hospitalRequest: any = {
      roleId: 2,                   // override or set as needed
      isApproved: false,            // override
      createdBy: "Admin",          // override
      dateCreated: new Date().toISOString(),
      hospitalRegistrationId: Number(Id),
      hospitalName: "",
      updatedBy: loggedInUser,
      note: rejectComment
    };

    try {
      await ApproveRejectHospitalRegistration(hospitalRequest);

      // 3. Show success toast
      toast.success("Hospital data approved successfully!", {
        position: "top-right",
        autoClose: 2000,
      });

      // 4. Redirect or clear
      navigate('/Facility/Review');
    } catch (error) {
      console.error("Error saving hospital data:", error);
      toast.error("An error occurred while saving hospital data.", {
        position: "top-right",
        autoClose: 2000,
      });
    } finally {
      setIsHospitalSubmitting(false);
    }
  };


  return (
    <>
      <Container>
        {/* Facility Information Card */}
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <AppCard>
              <AppCard title="Facility Information" bottomMargin>
                <div className="row mb-4">
                  <div className="col-md-12 col-lg-6">
                    <AppLabel label="Email" required />
                    <AppInputGroup
                      type="text"
                      name="userEmail"
                      isIconButton
                      actionText="Check Email"
                      onClick={handleValidateEmail}
                      value={userEmailData}

                      onCustomChange={(e) => setHospitalData({
                        ...hospitalData,
                        userEmail: e.target.value,
                      })
                      }
                      required
                    />
                    {emailError && (
                      <span style={{ color: emailErrorColor }}>{emailError}</span>
                    )}
                  </div>
                </div>
                <Row className="mb-4">
                  <Col>
                    <AppLabel label="Facility Type" required />
                    <Form.Select {...methods.register("hospitalTypeId", { valueAsNumber: true })} disabled={!fieldsEnabled}
                      value={
                        hospitalTypes.find(
                          (ht) => Number(ht.id) == hospitalData.hospitalTypeId)?.id || ""
                      }
                      onChange={(e) => {
                        const selectedId = Number(e.target.value);

                        // Update React-Hook-Form state
                        methods.setValue("hospitalTypeId", selectedId);

                        // Update local state for UI sync
                        setHospitalData((prev) => ({
                          ...prev,
                          hospitalTypeId: selectedId,
                        }));
                      }}
                    >
                      <option value="0">Select Hospital Type</option>
                      {hospitalTypes.map((option) => (
                        <option key={option.id} value={Number(option.id)}>
                          {option.value}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.hospitalTypeId && (
                      <p className="text-danger mb-0">
                        {errors.hospitalTypeId.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="Facility Name" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalName")}
                      value={hospitalData.hospitalName}
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          hospitalName: e.target.value,
                        })
                      }
                      disabled={!fieldsEnabled}
                    />
                    {errors.hospitalName && (
                      <p className="text-danger mb-0">
                        {errors.hospitalName.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="Facility Address" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalAddress")}
                      value={hospitalData.hospitalAddress}
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          hospitalAddress: e.target.value,
                        })
                      }
                      disabled={!fieldsEnabled}
                    />
                    {errors.hospitalAddress && (
                      <p className="text-danger mb-0">
                        {errors.hospitalAddress.message}
                      </p>
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <AppLabel label="City" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalCity")}  // This now controls 'city' entirely
                      disabled={!fieldsEnabled}
                    />
                    {errors.hospitalCity && (
                      <p className="text-danger mb-0">
                        {errors.hospitalCity.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="State" required />
                    <Form.Select
                      value={10}  // Florida=10
                      {...methods.register("stateId", { valueAsNumber: true })}
                      disabled //={!fieldsEnabled}
                    >
                      <option value={0}>Choose State...</option>
                      {states.map((st) => (
                        <option key={st.id} value={Number(st.id)}>
                          {st.value}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.stateId && (
                      <p className="text-danger mb-0">
                        {errors.stateId.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="County" required />
                    <Form.Select
                      {...methods.register("countyId", { valueAsNumber: true })}
                      value={counties.find((ct) => Number(ct.id) == Number(hospitalData.countyId))?.id || ""}
                      disabled={!fieldsEnabled}
                      onChange={(e) => {
                        const selectedId = e.target.value; // Keep it as a string

                        // Update React-Hook-Form state (as a number)
                        methods.setValue("countyId", Number(selectedId));

                        // Update local state (as a string)
                        setHospitalData((prev) => ({
                          ...prev,
                          countyId: selectedId, // Stay as string to match state
                        }));
                      }}
                    >
                      <option value="0">Select County</option>
                      {counties.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.value}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.countyId && (
                      <p className="text-danger mb-0">{errors.countyId.message}</p>
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Col>
                    <AppLabel label="Zip Code" required />
                    <Form.Control
                      type="text"
                      {...methods.register("hospitalZipCode")}
                      maxLength={5}
                      disabled={!fieldsEnabled}
                    />
                    {errors.hospitalZipCode && (
                      <p className="text-danger mb-0">
                        {errors.hospitalZipCode.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                  </Col>
                </Row>

              </AppCard>

              {/* User Account Information Card */}
              <AppCard title="User Account Information" bottomMargin>
                <Row className="mb-4">
                  <Col>
                    <AppLabel label="First Name" required />
                    <Form.Control
                      type="text"
                      {...methods.register("userFirstName")}
                      value={hospitalData.userFirstName}
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          userFirstName: e.target.value,
                        })
                      }
                      disabled={!fieldsEnabled}
                    />
                    {errors.userFirstName && (
                      <p className="text-danger mb-0">
                        {errors.userFirstName.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="Last Name" required />
                    <Form.Control
                      type="text"
                      {...methods.register("userLastName")}
                      value={hospitalData.userLastName}
                      onChange={(e) =>
                        setHospitalData({
                          ...hospitalData,
                          userLastName: e.target.value,
                        })
                      }
                      disabled={!fieldsEnabled}
                    />
                    {errors.userLastName && (
                      <p className="text-danger mb-0">
                        {errors.userLastName.message}
                      </p>
                    )}
                  </Col>
                  <Col>
                    <AppLabel label="Phone Number" required />
                    <Form.Control
                      type="text"
                      placeholder={
                        "10 digit phone number (ex: 555-555-5555)"
                      }
                      {...methods.register("userPhoneNumber")}
                      value={hospitalData.userPhoneNumber}
                      onChange={(e) => {
                        const { name, value } = e.target;
                        const formattedPhoneNumber =
                          formatPhoneNumber(value);
                        setHospitalData({
                          ...hospitalData,
                          userPhoneNumber: formattedPhoneNumber,
                        })
                      }}
                      disabled={!fieldsEnabled}
                    />
                    {errors.userPhoneNumber && (
                      <p className="text-danger mb-0">
                        {errors.userPhoneNumber.message}
                      </p>
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  {/* <Col>
                  <AppLabel label="Email Address" required />
                  <Form.Control
                    type="email"
                    value={hospitalData.AdminEmail}
                    onChange={(e) =>
                      setHospitalData({ ...hospitalData, AdminEmail: e.target.value })
                    }
                    disabled={!fieldsEnabled}
                  />
                </Col> */}
                  {/* <Col>
                  <AppLabel label="Role" required />
                  <Form.Select
                    value={hospitalData.RoleId}
                    onChange={(e) =>
                      setHospitalData({ ...hospitalData, RoleId: e.target.value })
                    }
                    disabled={!fieldsEnabled}
                  >
                    <option value="">Choose Role...</option>
                    {allRolesData.map((role) => (
                      <option key={role} value={role}>
                        {role}
                      </option>
                    ))}
                  </Form.Select>
                </Col> */}
                </Row>

              </AppCard>
              {/* Save Button */}
              <div className="text-end mb-">
                {type === "Review" ? (
                  <>
                    <AppButton
                      variant="secondary"
                      type="button"
                      onClick={() => navigate('/Facility/Review')}
                    >
                      Cancel
                    </AppButton> &nbsp;
                    <AppButton variant="primary" onClick={handleRejectClick}>
                      Reject
                    </AppButton> &nbsp;
                    <AppButton variant="primary" onClick={handleApprove} >
                      Approve
                    </AppButton>
                  </>
                ) : (
                  <div>
                    <AppButton
                      variant="secondary"
                      onClick={() => navigate('/Dashboard')}
                    >
                      Cancel
                    </AppButton> &nbsp;
                    <AppButton variant="primary" type="submit">
                      Submit
                    </AppButton>
                  </div>
                )}
              </div>

              {isRejectModalOpen && (
                <AppModal
                  title={"Reason for rejection"}
                  show={isRejectModalOpen}
                  primaryButtonText="Reject"
                  onPrimaryClicked={() => {
                    handleRejectSubmit();
                  }}
                  onSecondaryClicked={handleModalClose}
                  onHide={handleModalClose}
                >
                  <div>
                    {/* <label htmlFor="rejectComment">Reason for rejection</label> */}
                    <textarea
                      id="rejectComment"
                      value={rejectComment}
                      onChange={(e) => setRejectComment(e.target.value)}
                      placeholder="Enter reason for rejection"
                      rows={4}
                      style={{ width: "100%", margin: "10px 0" }}
                      maxLength={1500}
                    />

                  </div>
                </AppModal>
              )}
            </AppCard>
          </Form>
        </FormProvider>
      </Container>

    </>
  );

};

export default FacilityRegistration
